export const LOYALTY_ONLY_WARNING_MODAL_TEXT = {
  PROCEED: 'Proceed',
  BACK: 'Back',
  MESSAGE_PARAGRAPH_1:
    'You have locked this item only with Points. Point unlocking is only available on your White Label Site.',
  MESSAGE_PARAGRAPH_2:
    'If you would like this item to also be shown on TopFan.com, please also lock it with a secondary option (subscription, individual purchase and/or NFT).'
} as const;
